<script setup>

import {computed} from "@vue/reactivity";

const getIcon = computed(() => getCorrectIcon());

const props = defineProps({
  text: {type: String, default: 'Button', required: true},
  type: {type: String, default: 'primary'},
  icon: {type: String, default: ''},
  badgeData: {type: Number, default: 0}
})

function getCorrectIcon () {

  // Decimal HTML Entities thanks to graphemica.com

  switch (props.text) {

    case 'Add' : return '&#10010';
    case 'Save' :case 'Save & Submit' : return '&#128427';
    case 'Delete' : return '&#128465';
    case 'Edit' :return '&#9998;';
    case 'View' :return '&#128463';
    case 'Accept' : case 'Yes' : return '&#10004';
    case 'No' : return '&#10006';
    case 'Ok' : return '&#128505';
    case 'Export' : return '&#128464';
    case 'Refresh' : return '&#128472';
    case 'Documents' : case 'Docs' : return '&#128449';

    default: return '';
  }

}

</script>

<template class="cmp-button">
  <button
      v-if="!props.icon"
      id="vue-3-component-button1"
      class="cmp-button_button"
      @click="$emit('on-click')"
      :class="'cmp-button_button-' + props.type">
    <span v-if="props.badgeData" class="cmp-button_badge">{{props.badgeData}}</span>
    <span v-html="getIcon + ' ' + text"></span>
  </button>
  <button
      v-else
      id="vue-3-component-button2"
      class="cmp-button_button"
      @click="$emit('on-click')"
      :class="'cmp-button_button-' + props.type">
    <span v-if="props.badgeData" class="cmp-button_badge">{{props.badgeData}}</span>
    <span v-html="icon + ' ' + text"></span>
  </button>
</template>

<style lang="scss" scoped>

.cmp-button {

  &_button {
    position: relative;
    font-family: inherit;
    width: 70px;
    height: 25px;
    border-radius: 3px;
    box-shadow: none;
    border: none;
    margin-left: 3px;
    color: #fff;
    font-size: 12px;
    min-width: max-content;
    padding: 0 10px 2px 10px;
    transition: 0.2s;
    line-height: 24px;
    cursor: pointer;
  }

  &_button:hover {
    box-shadow: 1px 1px 2px 0px #888888;
  }

  &_button:disabled {
    opacity: 0.2;
  }

  &_button-primary {
    background-color: #31638c;
    border: 1px solid #31638c;
  }

  &_button-toolbar {
    background-image: linear-gradient(0deg, #eaeaea, #ffffff);
    border: 1px solid #cacaca;
    color: #000000;
  }

  &_button-secondary {
    background-color: #6c757d;
    border: 1px solid #6c757d;
  }

  &_button-success {
    background-color: #009688;
    border: 1px solid #009688;
  }

  &_button-danger {
    background-color: #ba545f;
    border: 1px solid #ba545f;
  }

  &_button-warning {
    background-color: #f0c042;
    border: 1px solid #f0c042;
  }

  &_button-info {
    background-color: #17a2b8;
    border: 1px solid #17a2b8;
  }

  &_button-plain {
    color: #ffffff;
    background-color: #8f6a82;
    border: 1px solid #8f6a82;
    //background-image: linear-gradient(rgb(221 123 74), #b15e3e);
  }

  &_badge {
    position: absolute;
    height: 8px;
    right: 4px;
    top: -9px;
    padding: 4px 4px 3px 4px;
    //background: #275087;
    background: #a44a4a;
    min-width: 5px;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    font-size: 9px;
    border-radius: 4px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

</style>
